import useClickListener from "../../utils/hooks/useClickListener"
import { containsValidTargetClass } from "./DatalayerMethods"

const DatalayerLinkClick = props => {
  const datalayerLinkClickHandler = event => {
    let validClasses = [
      "ter-bounded-card__link",
      "ter-product-intro-card__link",
      "text-link",
      "luna-link__link",
      "t2-icon-text-noodle__link",
      "t2-terra-text-link"
    ]
    if (containsValidTargetClass(validClasses, event?.target?.classList)) {
      const href = event.target.getAttribute("href") || null
      const name = event.target.getAttribute("data-name") || null
      const heading = event.target.getAttribute("data-heading") || null // TODO: add this in Terra
      const linkText =
        event.target.textContent || event.target.innerText || null

      /* Check if Link Appears in a Card or not */
      let isInCard = false
      let element = event.target
      while (element.parentNode) {
        if (
          element.parentNode.className &&
          element.parentNode.className.includes("-card")
        ) {
          isInCard = true
        }
        element = element.parentNode
      }

      window.dataLayer.push({
        event: "text_link_click",
        click_label: linkText?.trim(), //label of link text
        click_url: href,
        click_within_card: isInCard, //if click is within a card layout, true|false
        click_helper_text: linkText?.trim(),
        content_heading: heading,
        content_subheading: null,
        content_eyebrow: name,
        content_section: null,
        content_category: null,
        content_author: null,
      })
    }
  }

  useClickListener(datalayerLinkClickHandler, true)
}

export default DatalayerLinkClick
